const alert = "_alert_zx76t_10";
const content = "_content_zx76t_37";
const icon = "_icon_zx76t_48";
const actions = "_actions_zx76t_64";
const styles = {
  alert,
  content,
  "text-content": "_text-content_zx76t_44",
  icon,
  actions
};
export {
  actions,
  alert,
  content,
  styles as default,
  icon
};
//# sourceMappingURL=Alert.module.css.js.map
